import { defineStore } from "pinia";
import { ref } from "vue";

import type { PercentBasis } from "@/views/referring-portal/chartPercent";

/**
 * The referring portal Campaigns page's chart controls and the Data Table's vendor filter. Each
 * lived in a page-local `ref`, so opening a lead from the Data Table and coming back landed on All
 * Vendors — the table's search, sort and page survived (`tableStateStore`), the page around it did
 * not. The campaign and the tab are kept in the URL instead (`?campaign=`, `?tab=`, RAP-765).
 *
 * In-memory, like `tableStateStore` and `portalRangeStore`: survives route navigation, resets on a
 * reload. Cleared on sign-out (`clearAllStores`): the vendor picks are the last user's.
 */
export const usePortalCampaignsStore = defineStore("portalCampaigns", () => {
  /** The charts' vendor; "" is All Vendors. */
  const vendorId = ref("");
  const percentBasis = ref<PercentBasis>("overall");
  /** The Data Table's vendor filter (RAP-756); empty is every vendor. */
  const tableVendorNames = ref<string[]>([]);

  /** A setup store has no working Pinia `$reset`, so it defines its own. */
  function $reset() {
    vendorId.value = "";
    percentBasis.value = "overall";
    tableVendorNames.value = [];
  }

  return { $reset, percentBasis, tableVendorNames, vendorId };
});
